var scope_0 = require('/vercel/49ab048d/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ff1978852011dd4009b3d5bc780a316.js').default;export default
        Object.assign({}, scope_0 )
    